import { useCallback, useState } from "react";
import { searchPatients } from "../api/registrationService";

export function usePatientSearch() {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const runSearch = useCallback(async (criteria) => {
    setLoading(true);
    setError(null);
    try {
      const patients = await searchPatients(criteria);
      setResults(patients);
      return { patients, error: null };
    } catch (err) {
      const message = err.message || "Search failed";
      setError(message);
      setResults([]);
      return { patients: [], error: message };
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setResults([]);
    setError(null);
  }, []);

  return {
    results,
    loading,
    error,
    runSearch,
    reset,
  };
}
